<!-- appointment-details.component.html -->
<div mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle class="appointment-title">
    <div class="appointment-title-main">
        <h1 class="appointment-headline">Appointment Details</h1>
    </div>
    <button mat-button mat-dialog-close class="appointment-close">
        <mat-icon aria-hidden="false" aria-label="Close dialog">close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <mat-tab-group (selectedTabChange)="onTabChanged($event)" animationDuration="0ms">
        <mat-tab label="Details">
            <div class="container">
                <!-- Appointment header (moved out of the dialog title bar). -->
                <div class="appointment-summary">
                    <div class="appointment-summary-row d-flex flex-column flex-md-row justify-content-between align-items-md-start gap-3">
                        <div class="appointment-summary-left flex-grow-1">
                            <div class="appointment-summary-name">{{ getJoinedStudentNames() }}</div>
                            <div class="appointment-subline">
                                <mat-icon class="subline-icon">calendar_today</mat-icon>
                                <span>{{ processEventDetails()?.date }}</span>
                                <span *ngIf="processEventDetails()?.startTime"> · {{ processEventDetails()?.startTime }}<ng-container *ngIf="processEventDetails()?.endTime"> – {{ processEventDetails()?.endTime }}</ng-container></span>
                                <span *ngIf="this.instructorName">
                                    · with {{ this.instructorName }}
                                </span>
                            </div>
                        </div>

                        <div class="appointment-summary-right d-flex">
                            <div class="account-stat text-center">
                                <div class="summary-hero-appt-details">
                                    {{ this.studentInfo?.field_total_lessons_taken_all | number:'1.0-1' }}
                                </div>
                                <small>Taken</small>
                            </div>
                            <div class="account-stat text-center">
                                <div class="summary-hero-appt-details">
                                    {{ ((this.studentInfo?.field_total_lessons_enrolled || 0) - (this.studentInfo?.field_total_lessons_taken_all || 0)) | number:'1.0-1' }}
                                </div>
                                <small>Remaining</small>
                            </div>
                            <div class="account-stat text-center">
                                <div class="summary-hero-appt-details"
                                     [style.color]="this.studentInfo?.field_total_lessons_paid_ahead < 0 ? 'red' : ''">
                                    {{ this.studentInfo?.field_total_lessons_paid_ahead | number:'1.0-1' }}
                                </div>
                                <small>Paid Ahead</small>
                            </div>
                        </div>
                    </div>

                    <!-- Status + info chips: full-width row underneath both columns. -->
                    <div class="appointment-chips" *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'lesson'">
                        <span class="chip" [class.chip-active]="this.isStanding">
                            <mat-icon class="chip-icon">autorenew</mat-icon>
                            {{ this.isStanding ? 'Standing' : 'Not standing' }}
                        </span>
                        <span class="chip" [class.chip-active]="this.isConfirmed">
                            <mat-icon class="chip-icon">{{ this.isConfirmed ? 'check' : 'help_outline' }}</mat-icon>
                            {{ this.isConfirmed ? 'Confirmed' : 'Unconfirmed' }}
                        </span>
                        <span class="chip" *ngIf="this.notificationHistoryLoading">
                            <mat-icon class="chip-icon">hourglass_empty</mat-icon>
                            Checking reminders…
                        </span>
                        <span class="chip" *ngIf="!this.notificationHistoryLoading"
                              [class.chip-active]="this.reminderActuallySent">
                            <mat-icon class="chip-icon">{{ this.reminderActuallySent ? 'notifications_active' : 'notifications_off' }}</mat-icon>
                            {{ this.reminderActuallySent ? 'Reminder sent' : 'Reminder not sent' }}
                        </span>
                        <span class="chip chip-info" *ngIf="this.attachedEnrollmentId">
                            <mat-icon class="chip-icon">link</mat-icon>
                            Enrollment #{{ this.attachedEnrollmentId }}<ng-container *ngIf="this.attachedEnrollmentPackageAbbreviation"> - {{ this.attachedEnrollmentPackageAbbreviation }}</ng-container>
                        </span>
                        <span class="chip chip-info"
                              *ngIf="this.nextScheduledPayment?.field_payment_amount || this.nextScheduledPayment?.field_payment_date"
                              [matTooltip]="nextScheduledPaymentRemaining?.tax ? ((nextScheduledPaymentRemaining.amount | studioCurrency) + ' + ' + (nextScheduledPaymentRemaining.tax | studioCurrency) + ' ' + (taxMode?.label || 'tax')) : ''">
                            <mat-icon class="chip-icon">payments</mat-icon>
                            <ng-container *ngIf="this.nextScheduledPayment?.field_payment_amount">
                                {{ nextScheduledPaymentRemaining?.total | studioCurrency }}
                            </ng-container>
                            <ng-container *ngIf="this.nextScheduledPayment?.field_payment_date">
                                due {{ this.nextScheduledPayment.field_payment_date | date }}
                            </ng-container>
                        </span>
                    </div>
                </div>

                <div class>
                    <table class>

                        <!-- <tr>
                            <td>
                                &nbsp;
                            </td>
                            <td>
                                &nbsp;
                            </td>
                            <td class="text-nowrap">
                                <div class="d-flex justify-content-between">
                                    <div style="width:50px" class="col-2 text-center">
                                        <div style="border: 12px solid #68ff94;" class="summary-hero-appt-details">
                                            {{ 5 }}
                                        </div>
                                        <div class="text-center"><small>Enrolled</small></div>
                                    </div>

                                    <div style="width:50px"  class="col-2 text-center">
                                        <div style="border: 12px solid #68ff94;" class="summary-hero-appt-details">
                                            {{ 5 }}
                                        </div>
                                        <div class="text-center"><small>Taken</small></div>
                                    </div>

                                    <div style="width:50px"  class="col-2 text-center">
                                        <div style="border: 12px solid #FCC761;" class="summary-hero-appt-details">
                                            {{ 5 }}
                                        </div>
                                        <div class="text-center"><small>Remaining</small></div>
                                    </div>
                                </div>
                            </td>
                        </tr> -->

                        <!-- Date / Start Time / End Time row removed: shown inline on the
                             current lesson within the Upcoming Lessons panel below.
                             Still rendered for non-lesson appointment types. -->
                        <tr *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType != 'lesson'">
                            <td colspan="4">
                                <div class="d-flex justify-content-between">
                                  <span class="col-4">
                                    <strong>Date:</strong>
                                    {{ processEventDetails()?.date }}
                                  </span>
                                  <span class="col-4">
                                    <strong>Start Time:</strong>
                                    {{ processEventDetails()?.startTime }}
                                  </span>
                                  <span class="col-4">
                                    <strong class="text-nowrap">End Time:</strong>
                                    {{ processEventDetails()?.endTime }}
                                  </span>
                                </div>
                              </td>
                        </tr>

                        <tr>
                            <td colspan="4">
                                <div class="col-4 mt-1 d-grid">
                                <button mat-flat-button class="potential-lesson-button"
                                        *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'services' &&
                                            this.injectedDialogData?.event?._def?.extendedProps?.eventDetails?.data?.field_type == '1419'"
                                        [disabled]="isConvertingLesson"
                                        (click)="convertPotentialLesson()">
                                <mat-icon *ngIf="isConvertingLesson" class="mat-icon-animate-spin">autorenew</mat-icon>
                                <ng-container *ngIf="!isConvertingLesson">
                                  <mat-icon>transform</mat-icon>
                                  <span>Convert Lesson</span>
                                </ng-container>
                                <span *ngIf="isConvertingLesson">Converting...</span>
                                </button>
                            </div>
                            </td>
                        </tr>


                        <tr
                            *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'lesson'">
                            <td colspan="4" class="p-0">
                                <div class="row g-3">
                                    <!-- Upcoming lessons column -->
                                    <div class="lesson-reminders-cell col-12 col-md-6">
                                <div class="section-label">Upcoming Lessons</div>
                                <div *ngIf="!this.displayLessonList || this.displayLessonList.length === 0"
                                     class="text-muted">
                                    None scheduled
                                </div>
                                <ng-container *ngIf="this.displayLessonList && this.displayLessonList.length > 0">
                                    <ng-container *ngFor="let upcomingLesson of this.displayLessonList; index as i">
                                        <div *ngIf="(this.upcomingLessonsExpanded || i < 4) && upcomingLesson && upcomingLesson.toString().length > 0"
                                             class="lesson-row d-flex justify-content-between align-items-center"
                                             [class.is-current]="isCurrentLesson(upcomingLesson)">
                                            <span class="d-flex align-items-center">
                                                <mat-icon *ngIf="isCurrentLesson(upcomingLesson)"
                                                          class="lesson-arrow">arrow_forward</mat-icon>
                                                <span class="lesson-date">{{formatUpcomingLessonDate(upcomingLesson)}}</span>
                                            </span>
                                            <span class="lesson-time">
                                                <ng-container *ngIf="isCurrentLesson(upcomingLesson) && processEventDetails()?.endTime; else justStart">
                                                    {{processEventDetails()?.startTime}} – {{processEventDetails()?.endTime}}
                                                </ng-container>
                                                <ng-template #justStart>
                                                    {{formatUpcomingLessonTime(upcomingLesson)}}
                                                </ng-template>
                                            </span>
                                        </div>
                                    </ng-container>
                                    <button *ngIf="!this.upcomingLessonsExpanded && this.displayLessonList.length > 4"
                                            type="button"
                                            class="btn btn-link p-0 show-more-link"
                                            (click)="this.upcomingLessonsExpanded = true">
                                        Show {{this.displayLessonList.length - 4}} more
                                        <mat-icon class="show-more-arrow">arrow_forward</mat-icon>
                                    </button>
                                    <button *ngIf="this.upcomingLessonsExpanded && this.displayLessonList.length > 4"
                                            type="button"
                                            class="btn btn-link p-0 show-more-link"
                                            (click)="this.upcomingLessonsExpanded = false">
                                        Show less
                                    </button>
                                </ng-container>
                                    </div>

                                    <!-- Reminder history column -->
                                    <div class="reminder-history-cell col-12 col-md-6">
                                <div class="section-label">Reminder History</div>
                                <div *ngIf="this.notificationHistoryLoading" class="text-muted small">Loading…</div>
                                <div *ngIf="!this.notificationHistoryLoading && this.notificationHistoryError"
                                     class="text-muted small">
                                    {{this.notificationHistoryError}}
                                </div>
                                <div *ngIf="!this.notificationHistoryLoading && !this.notificationHistoryError && this.notificationHistory.length === 0"
                                     class="text-muted small">
                                    None recorded
                                </div>
                                <div *ngIf="!this.notificationHistoryLoading && this.notificationHistory.length > 0">
                                    <div *ngFor="let n of this.notificationHistory"
                                         class="reminder-entry d-flex align-items-start"
                                         [matTooltip]="n.message_body || ''"
                                         matTooltipClass="reminder-tooltip"
                                         matTooltipPosition="left"
                                         [matTooltipDisabled]="!n.message_body">
                                        <ng-container *ngIf="n.notification_type === 'opt_out'; else reminderIcon">
                                            <mat-icon class="reminder-icon icon-warning">block</mat-icon>
                                        </ng-container>
                                        <ng-template #reminderIcon>
                                            <mat-icon *ngIf="n.status === 'sent' || n.status === 'delivered'"
                                                      class="reminder-icon icon-success">check_circle</mat-icon>
                                            <mat-icon *ngIf="n.status === 'failed' || n.status === 'undelivered'"
                                                      class="reminder-icon icon-danger">error</mat-icon>
                                            <mat-icon *ngIf="n.status === 'Pending' || (!n.status && n.notification_type !== 'opt_out')"
                                                      class="reminder-icon icon-muted">schedule</mat-icon>
                                        </ng-template>
                                        <div class="flex-grow-1">
                                            <div class="reminder-headline">
                                                <ng-container *ngIf="n.notification_type === 'opt_out'">
                                                    {{n.channel | uppercase}} opted out
                                                </ng-container>
                                                <ng-container *ngIf="n.notification_type !== 'opt_out'">
                                                    {{n.channel | uppercase}} {{n.status}}
                                                </ng-container>
                                            </div>
                                            <div *ngIf="n.sent_date_display" class="reminder-meta text-muted">
                                                {{n.sent_date_display}}
                                            </div>
                                            <div *ngIf="n.error_message" class="reminder-error text-danger small">
                                                {{n.error_message}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <ng-container *ngIf="_permissionsService.canAccess('communication_buttons')">
                                <div class="section-label reach-out-label">Reach Out</div>
                                <div class="reach-out-buttons d-flex flex-wrap">
                                    <button [matTooltip]="this.studentDetails?.studentEmails?.length
                                                ? 'Send the lesson reminder email now to: ' + this.studentDetails?.studentEmails.join(', ')
                                                : 'No email on file, cannot send reminder email.'"
                                            matTooltipClass="reminder-tooltip"
                                            [disabled]="!this.studentDetails?.studentEmails?.length"
                                            class="reach-out-btn"
                                            mat-raised-button
                                            color="primary"
                                            (click)="sendEmailLessonReminder(this.entityID);">
                                        <mat-icon>email</mat-icon> Email
                                    </button>
                                    <a href="tel:{{ getFormattedPhoneNumbers() }}">
                                        <button [matTooltip]="getFormattedPhoneNumbers()
                                                    ? 'Open your phone to call: ' + getFormattedPhoneNumbers()
                                                    : 'No phone number on file.'"
                                                matTooltipClass="reminder-tooltip"
                                                [disabled]="!getFormattedPhoneNumbers()"
                                                class="reach-out-btn"
                                                mat-raised-button
                                                color="primary">
                                            <mat-icon>call</mat-icon> Call
                                        </button>
                                    </a>
                                    <button [matTooltip]="getFormattedPhoneNumbers()
                                                ? 'Send the lesson reminder SMS now to: ' + getFormattedPhoneNumbers()
                                                : 'No phone number on file, cannot send SMS.'"
                                            matTooltipClass="reminder-tooltip"
                                            [disabled]="!getFormattedPhoneNumbers()"
                                            class="reach-out-btn"
                                            mat-raised-button
                                            color="primary"
                                            (click)="sendSMSLessonReminder(this.entityID)">
                                        <mat-icon>sms</mat-icon> Text
                                    </button>
                                </div>
                                </ng-container>
                                    </div><!-- /reminder-history-cell -->
                                </div><!-- /row -->
                            </td>
                        </tr>


                        <tr *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'lesson' || this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'services'">
                            <td [attr.colspan]="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'lesson' ? 4 : 2"
                                class="no-wrap">
                                <strong>Notes: </strong>
                                {{ this.eventNotes }}
                            </td>
                            <td colspan="2" class="no-wrap"
                                *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'services'">
                                <ng-container *ngIf="_permissionsService.canAccess('communication_buttons')">
                                <button matTooltip="{{ this.studentDetails?.studentEmails?.length ? this.studentDetails?.studentEmails.join(', ') : 'Disabled' }}"
                                        class="confirmAppointment me-1"
                                        mat-flat-button
                                        (click)="sendEmailLessonReminder(this.entityID);">
                                    <mat-icon>email</mat-icon> Email
                                </button>
                                <a href="tel:{{ getFormattedPhoneNumbers() }}">
                                    <button matTooltip="{{ getFormattedPhoneNumbers() }}"
                                            class="confirmAppointment me-1"
                                            mat-flat-button
                                            (click)="return;">
                                        <mat-icon>call</mat-icon> Call
                                    </button>
                                </a>
                                <button matTooltip="{{ getFormattedPhoneNumbers() }}"
                                        class="confirmAppointment me-1"
                                        mat-flat-button
                                        (click)="sendSMSLessonReminder(this.entityID)">
                                    <mat-icon>sms</mat-icon> Text
                                </button>
                                </ng-container>
                            </td>
                        </tr>

                    </table>

                </div>
            </div>

        </mat-tab>

        <!-- Edit Lesson -->
        <mat-tab
            *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType != 'schedules'
            && this.injectedDialogData?.event?._def?.extendedProps?.appointmentType != 'group_lesson'
            && this.injectedDialogData?.event?._def?.extendedProps?.appointmentType != 'schedules'"
            label="Edit Status">
            <app-update-status
                [appointmentType]="this.appointmentType"
                [status]="this.status"
                [attendeesID]="this.attendeesID"
                [studentName]="this.studentName"
                [eventID]="this.eventID"></app-update-status>
        </mat-tab>

        <!-- Edit Status Group Lesson -->
        <mat-tab #groupLessonTab
            *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType != 'schedules'
            && this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'group_lesson'
            && this.injectedDialogData?.event?._def?.extendedProps?.appointmentType != 'schedules'"
            label="Edit Status">
            <app-update-status-group-lesson
                #updateStatusGroupLesson
                [appointmentType]="this.appointmentType"
                [eventID]="this.entityID">
            </app-update-status-group-lesson>
        </mat-tab>

        <!-- Lesson Blocks -->
        <mat-tab
            *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'lesson'"
            label="Lesson Blocks">

            <form [formGroup]="this.lessonBlockForm"
                (ngSubmit)="lessonBlockFormSubmit(form)" #form="ngForm"
                class="form">
                <div class="container pt-2">
                    <div class="row mb-1">
                        <div class="col-4">
                            <strong>Student:</strong> {{ this.studentName }}
                        </div>
                        <div class="col-4">
                            <strong>Instructor:</strong> {{this.injectedDialogData?.event?._def?.extendedProps?.instructorName}}
                        </div>
                        <div class="col-4">
                            <strong>Studio:</strong> {{
                            this.studioInformationConfig?.field_studio_display_name?.[0]?.value
                            }}
                        </div>
                    </div>

                    <div class="row mb-1">
                        <div class="col-4">
                            <strong class="text-nowrap">Appointment Type:</strong>
                            {{this.injectedDialogData?.event?._def?.extendedProps?.appointmentType}}
                        </div>
                        <div class="col-4">
                            <strong>Start Time:</strong>
                            {{ processEventDetails()?.startTime }}
                        </div>
                        <div class="col-4">
                            <strong class="text-nowrap">End Time:</strong>
                            {{ processEventDetails()?.endTime }}
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-4">
                            <strong>Date:</strong>
                            {{ processEventDetails()?.date }}
                        </div>
                    </div>

                    <div class="row mb-1">
                        <div class="col-12">
                            <mat-form-field class="full-width-field" appearance="outline">
                                <mat-label>Material Covered</mat-label>
                                <textarea ngModel
                                    formControlName="field_material_covered"
                                    matInput placeholder rows="2"></textarea>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mb-1">
                        <div class="col-12">
                            <mat-form-field class="full-width-field" appearance="outline">
                                <mat-label>Comments</mat-label>
                                <textarea ngModel
                                    formControlName="field_comments"
                                    matInput placeholder rows="2"></textarea>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <strong class="text-nowrap">Lesson Rating:</strong>
                        <div class="col-12">
                            <div style="float:left;">
                                <ngx-star-rating
                                    formControlName="field_lesson_rating"
                                    [id]="'rating'"></ngx-star-rating>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-6">
                            <div class="signature-box p-2 border rounded">
                                <p class="fw-bold mb-1 small">Teacher Initials:</p>
                                <div class="signature-container bg-light p-1 border rounded"
                                    style="min-height: 100px; touch-action: none;">
                                    <canvas
                                        *ngIf="(!this.eventEntityData?.['field_instructor_signature']?.[0]?.['url'] || !this.eventEntityData) && isLessonBlocksTabActive"
                                        width="250px" height="100px"
                                        class="signature-canvas" #SignatureInstructor>
                                    </canvas>
                                    <div
                                        *ngIf="this.eventEntityData?.['field_instructor_signature']?.[0]?.['url']"
                                        class="text-center">
                                        <img class="img-fluid"
                                            [src]="this.eventEntityData?.['field_instructor_signature'][0]?.['url']" />
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mt-1">
                                    <button class="mt-0 p-1" [class.display-none]="!detectSignatureInstructor"
                                        type="button" mat-stroked-button
                                        (click)="signatureClearInstructor()"
                                        *ngIf="!this.eventEntityData?.['field_instructor_signature']?.[0]?.['url']">Clear</button>
                                    <p class="mb-0 text-end small"><span class="fw-bold">Date:</span> {{
                                        processEventDetails()?.date }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="signature-box p-2 border rounded">
                                <p class="fw-bold mb-1 small">Student Initials:</p>
                                <div class="signature-container bg-light p-1 border rounded"
                                    style="min-height: 100px; touch-action: none;">
                                    <canvas
                                        *ngIf="(!this.eventEntityData?.['field_signature_student']?.[0]?.['url'] || !this.eventEntityData) && isLessonBlocksTabActive"
                                        width="250px" height="100px"
                                        class="signature-canvas" #SignatureStudent>
                                    </canvas>
                                    <div
                                        *ngIf="this.eventEntityData?.['field_signature_student']?.[0]?.['url']"
                                        class="text-center">
                                        <img class="img-fluid"
                                            [src]="this.eventEntityData?.['field_signature_student'][0]?.['url']" />
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mt-1">
                                    <button class="mt-0 p-1" [class.display-none]="!detectSignatureStudent"
                                        type="button" mat-stroked-button
                                        (click)="signatureClearStudent()"
                                        *ngIf="!this.eventEntityData?.['field_signature_student']?.[0]?.['url']">Clear</button>
                                    <p class="mb-0 text-end small"><span class="fw-bold">Date:</span> {{
                                        processEventDetails()?.date }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-6 text-center">
                            <button style="width:150px;"
                                    (click)="lessonBlockFormSubmit(f, 'email');"
                                    type="button"
                                    mat-button
                                    [disabled]="isLoading"
                                    class="save-exit-button py-1">
                                <div class="button-content">
                                    <mat-spinner *ngIf="isLoading && activeButton === 'email'" diameter="20"></mat-spinner>
                                    <span>
                                        <ng-container *ngIf="isLoading && activeButton === 'email'">Sending email...</ng-container>
                                        <ng-container *ngIf="!(isLoading && activeButton === 'email')">Save & Email</ng-container>
                                    </span>
                                </div>
                            </button>
                        </div>
                        <div class="col-6 text-center">
                            <button style="width:150px;"
                                    (click)="lessonBlockFormSubmit(f);"
                                    type="button"
                                    mat-button
                                    [disabled]="isLoading"
                                    class="save-exit-button py-1">
                                <div class="button-content">
                                    <mat-spinner *ngIf="isLoading && activeButton === 'save'" diameter="20"></mat-spinner>
                                    <span>
                                        <ng-container *ngIf="isLoading && activeButton === 'save'">Saving...</ng-container>
                                        <ng-container *ngIf="!(isLoading && activeButton === 'save')">Save & Exit</ng-container>
                                    </span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </form>

        </mat-tab>
    </mat-tab-group>

<!-- Primary action grid lives inside mat-dialog-content so the dialog scrolls
     as one region. Material's mat-dialog-actions slot is reserved for short
     footer buttons (which this dialog doesn't use), and using it for a tall
     button grid required overriding Material's sticky-footer/scroll behavior.
     Only shown on the Details tab. The other tabs have their own controls. -->
<div class="appointment-actions" *ngIf="this.isDetailsTabActive">
    <!-- Future Appointments group (cancel/delete the recurring series) -->
    <div class="future-appointments-bar w-100 d-flex flex-column flex-sm-row justify-content-sm-evenly align-items-sm-center gap-2 p-2 mb-2">
        <div class="align-middle">
            Future Appointments:
        </div>
        <div class="align-middle">
            <button mat-flat-button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType === 'services' && _permissionsService.canAccess('lessons_cancel')"
                    [disabled]="isRefreshing"
                    (click)="openDialog(CancelFutureAppointmentComponent, null, {
                        entityID: this.entityID,
                        field_studio_reference: this._authService.selectedStudio?.id,
                        parentID: this.injectedDialogData?.event?._def?.extendedProps?.['parentID'],
                        bundle: this.injectedDialogData?.event?._def?.extendedProps?.appointmentType
                    })">Cancel Future Services</button>
            <button mat-flat-button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType === 'lesson' && _permissionsService.canAccess('lessons_cancel')"
                    [disabled]="isRefreshing"
                    (click)="openDialog(CancelFutureAppointmentComponent, null, {
                        entityID: this.entityID,
                        field_studio_reference: this._authService.selectedStudio?.id,
                        parentID: this.injectedDialogData?.event?._def?.extendedProps?.['parentID'],
                        bundle: this.injectedDialogData?.event?._def?.extendedProps?.appointmentType
                    })">Delete Future Appointments</button>
            <button mat-flat-button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType === 'schedules' && _permissionsService.canAccess('lessons_cancel')"
                    [disabled]="isRefreshing"
                    (click)="openDialog(CancelFutureAppointmentComponent, null, {
                        entityID: this.entityID,
                        field_studio_reference: this._authService.selectedStudio?.id,
                        parentID: this.injectedDialogData?.event?._def?.extendedProps?.['parentID'],
                        bundle: this.injectedDialogData?.event?._def?.extendedProps?.appointmentType
                    })">Delete Future Schedules</button>
            <button mat-flat-button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType === 'group_lesson' && _permissionsService.canAccess('lessons_cancel')"
                    [disabled]="isRefreshing"
                    (click)="openDialog(CancelFutureAppointmentComponent, null, {
                        entityID: this.entityID,
                        field_studio_reference: this._authService.selectedStudio?.id,
                        parentID: this.injectedDialogData?.event?._def?.extendedProps?.['parentID'],
                        bundle: this.injectedDialogData?.event?._def?.extendedProps?.appointmentType
                    })">Delete Future Group Lessons</button>
        </div>
    </div>

    <!-- Lesson / service / group-lesson actions -->
    <ng-container *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType != 'schedules'">
        <div class="row w-100 g-2">
            <div class="col-12 col-sm-6 col-md-4 d-grid" *ngIf="_permissionsService.canAccess('lessons_create')">
                <button class="addLesson" mat-flat-button
                    [disabled]="isRefreshing"
                    (click)="openLesson()">
                    Add Lesson
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-grid" *ngIf="_permissionsService.canAccess('lessons_create')">
                <button class="addService" mat-flat-button
                    [disabled]="isRefreshing"
                    (click)="openEntityComponent(EventServicesEntityComponent, 'events', 'services', 'create', null, {
                        '__field_students_inline_form': {
                            'type': 'attendees',
                            'bundle': 'attendance',
                            'field_student_account': (this.studentDetails?.studentName + ' (' + this.studentDetails?.studentAccountId + ')')
                        }
                    })">
                    Add Service
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-grid" *ngIf="_permissionsService.canAccess('lessons_edit')">
                <button class="postLesson" mat-flat-button
                    [disabled]="isRefreshing || isEventPassed || this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'group_lesson'"
                    (click)="openDialog(PostLessonComponent, null, {
                        entityID: this.entityID,
                        eventData: this.eventData
                    })">Post Lesson</button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-grid" *ngIf="_permissionsService.canAccess('students_view')">
                <button mat-flat-button
                    [disabled]="isRefreshing || !this.studentDetails?.studentTargetId"
                    class="studentDashboard text-nowrap"
                    (click)="openDialog(StudentDashboardWrapperComponent, 'largerScreenDashboard', {
                        student_id: this.studentDetails?.studentTargetId
                    })">
                    Student Dashboard
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-grid" *ngIf="_permissionsService.canAccess('enrollments_create')">
                <button mat-flat-button class="enrollment"
                    [disabled]="isRefreshing"
                    (click)="openEnrollment()" mat-button>
                    Enrollment
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-grid" *ngIf="_permissionsService.canAccess('payments_collect')">
                <button mat-flat-button class="payment"
                    [disabled]="isRefreshing"
                    (click)="openEntityComponent(PaymentEntityComponent, 'payments', 'payment', 'create', '', {
                        'field_student_name': (this.studentDetails?.studentName + ' (' + this.studentDetails?.studentAccountId + ')')
                    })">
                    Payment
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-grid" *ngIf="_permissionsService.canAccess('lessons_edit')">
                <button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'lesson'"
                    mat-flat-button class="editLesson"
                    [disabled]="isRefreshing"
                    (click)="openEntityComponent(EventLessonEntityComponent, 'events', 'lesson', 'edit', this.entityID)">
                    Edit Lesson
                </button>
                <button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'group_lesson'"
                    mat-flat-button class="editLesson"
                    [disabled]="isRefreshing"
                    (click)="openEntityComponent(EventGroupLessonEntityComponent, 'events', 'group_lesson', 'edit', this.entityID)">
                    Edit Group Lesson
                </button>
                <button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'services'"
                    mat-flat-button class="editLesson"
                    [disabled]="isRefreshing"
                    (click)="openEntityComponent(EventServicesEntityComponent, 'events', 'services', 'edit', this.entityID)">
                    Edit Service
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-grid" *ngIf="_permissionsService.canAccess('lessons_cancel')">
                <button class="cancelReschedule" mat-flat-button
                    [disabled]="isRefreshing"
                    (click)="openDialog(CancelRescheduleComponent, null, {
                                entityID: this.entityID,
                                appointmentType: this.injectedDialogData?.event?._def?.extendedProps?.appointmentType,
                                eventData: this.eventData
                            })">Cancel/RS</button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-grid" *ngIf="_permissionsService.canAccess('lessons_cancel')">
                <button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'lesson'"
                    mat-flat-button color="accent"
                    [disabled]="isRefreshing"
                    (click)="openEntityComponent(EventLessonEntityComponent, 'events', 'lessons', 'delete', this.entityID);">
                    Delete
                </button>
                <button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'group_lesson'"
                    mat-flat-button color="accent"
                    [disabled]="isRefreshing"
                    (click)="openEntityComponent(EventGroupLessonEntityComponent, 'events', 'group_lesson', 'delete', this.entityID);">
                    Delete
                </button>
                <button
                    *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'services'"
                    mat-flat-button color="accent"
                    [disabled]="isRefreshing"
                    (click)="openEntityComponent(EventServicesEntityComponent, 'events', 'services', 'delete', this.entityID);">
                    Delete
                </button>
            </div>
        </div>
    </ng-container>

    <!-- Schedule actions -->
    <ng-container *ngIf="this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'schedules'">
        <button *ngIf="_permissionsService.canAccess('lessons_edit')" mat-flat-button color="accent" class="me-1"
            (click)="openEntityComponent(EventScheduleEntityComponent, 'events', 'schedules', 'edit', this.entityID)">
            Edit Schedule
        </button>
        <button *ngIf="_permissionsService.canAccess('lessons_cancel')" [disabled]="this.entityID == undefined"
            mat-flat-button color="accent"
            (click)="openEntityComponent(EventScheduleEntityComponent, 'events', 'schedules', 'delete', this.entityID)">
            Delete
        </button>
    </ng-container>
</div>
</mat-dialog-content>
